import { BusinessPractitionersDirectory } from "@/features/business-practitioners/components/business-practitioners-directory";

/** GA/SA-only directory of Business-Practitioner firms (see SuperAdminRoute). */
export default function BusinessPractitionersPage() {
  return <BusinessPractitionersDirectory />;
}
